// CLASSES
import AppConfig from "@classes/AppConfig";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields} = state;

	if (!fields.checkbox_customer_kyc_forkop.checked) {
		return false;
	}

	if (!fields.checkbox_customer_kyc_isk.checked) {
		return false;
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/IskBilagor.fulfillment.js